import { FC } from 'react'
import { Modal } from 'react-bootstrap-v5'
import { KTSVG } from '../../../../_metronic/helpers';
import { useConfirmAction } from '../../../hooks/utils/useConfirmAction';
import { showErrorAlert } from '../../../helpers/alert';
import { ExperienceSummary } from '../../teamExperiences/models/ExperienceSummaryModel';

type Props = {
	show: boolean;
	onClose: () => void;
	onSubmit?: () => void;
	onLoad?: (isloaded: boolean) => void;
	experience:ExperienceSummary;
}

export const CancelExperiencePolicyModal: FC<Props> = ({ show, onClose, onLoad, onSubmit, experience }) => {
	const confirm = useConfirmAction();
	const onHandleCancel = async () => {
		let cancel = await confirm({title:'Cancel',message:`Do you want to proceed with canceling this experience '${experience.title}'?`});
		if(cancel){
			showErrorAlert({ title: 'Coming soon.', message: '' });
			return;
			onLoad(true);
			setTimeout(() => {
				onLoad(false);
				showErrorAlert({title:'Experience canceled',message:'The experience has been canceled.'})
				onSubmit();
			}, 5000);
		}
	}

	return (
		<Modal show={show} onHide={onClose} centered backdrop="static" dialogClassName='experience-user-cancel'>
			<div className='cancel-experience'>
				<h2 className="cancel-experience__title">
					Cancel This Experience?
				</h2>

				<div className="cancel-experience__content">

					{/* Row 1 */}
					<div className="cancel-experience__row">
						<div className="cancel-experience__label">
							<span className="label-title">Within</span>
							<span className="label-text">48 hours of booking</span>
						</div>
						<div className="cancel-experience__description">
							<span className="desc-title">Full refund</span>
							<span className="desc-text">
								You’ll get back 100% of what you paid—no cancellation fee.
							</span>
						</div>
					</div>

					{/* Row 2 */}
					<div className="cancel-experience__row">
						<div className="cancel-experience__label">
							<span className="label-title">Before</span>
							<span className="label-text">Aug 7, 2:00 PM</span>
						</div>
						<div className="cancel-experience__description">
							<span className="desc-title">Partial refund</span>
							<span className="desc-text">
								You’ll receive an 80% refund. A 20% cancellation fee applies for preparation costs.
							</span>
						</div>
					</div>

					{/* Row 3 */}
					<div className="cancel-experience__row">
						<div className="cancel-experience__label">
							<span className="label-title">After</span>
							<span className="label-text">Aug 7, 2:00 PM</span>
						</div>
						<div className="cancel-experience__description">
							<span className="desc-title">Partial refund</span>
							<span className="desc-text">
								You’ll receive a 50% refund. The remaining 50% is non-refundable due to last-minute cancellation.
							</span>
						</div>
					</div>

					{/* Row 4 */}
					<div className="cancel-experience__row">
						<div className="cancel-experience__label">
							<span className="label-title">After</span>
							<span className="label-text">Aug 27, 2:00 PM</span>
						</div>
						<div className="cancel-experience__description">
							<span className="desc-title">No refund</span>
							<span className="desc-text">
								Cancellations made less than 24 hours before the experience start time are not eligible for a refund.
							</span>
						</div>
					</div>

					{/* Refund eligibility */}
					<div className="cancel-experience__refund">
						<div className="refund-label">Refund Eligibility</div>
						<p className="refund-text">
							If you paid using credits or made a partial payment, your refund will depend on how much you’ve paid at the time of cancellation.
							Credits refunded follow the same percentage rules and are returned to your account wallet.
						</p>

						<div className="refund-warning">
							This action cannot be undone.
						</div>
					</div>

					{/* Actions */}
					<div className="cancel-experience__actions">
						<div role='button' onClick={onClose} className={`tap-add-experience-2-btn-secondary`}>
							Keep Experience Active
						</div>

						<div role='button' onClick={onHandleCancel} className="tap-add-experience-2-btn-main tap-flex-center">
							<div className='tap-host-button-text tap-flex-center'>
								Cancel anyway
								&nbsp;<KTSVG path='/media/svg/nobilis/teams_and_partner/waitlist_nb_btn_icon_host_experience_btn.svg' />
							</div>
						</div>
					</div>

				</div>
			</div>
		</Modal>
	)
}
